import React from 'react';
import I18n from '../../I18n';
import {Button} from 'rctui';

const KeyValue = React.createClass({
  displayName: 'KeyValue',

  delimiter: ',',

  getInitialState: function () {
    let typeIsString = typeof this.props.value === 'string',
      value = {};

    if (typeIsString) {
      let list = this.props.value.split(this.delimiter);
      if (list.length > 1) {
        for (let i = 0; i < list.length; i += 2) {
          value[list[i]] = list[i + 1];
        }
      }
    } else {
      value = Object.assign({}, this.props.value);
    }

    return {
      value: value,
      typeIsString: typeIsString
    };
  },

  getDefaultProps: function () {
    return {
      disabled: false,
      name: '',
      value: ''
    };
  },

  propTypes: {
    name: React.PropTypes.string.isRequired,
    disabled: React.PropTypes.bool
  },

  onSave: function (key) {
    let stateValue = Object.assign({}, this.state.value),
      nodeKey = this.refs[key + "-key"],
      nodeValue = this.refs[key + "-value"],
      newKey = nodeKey.value,
      newValue = nodeValue.value;

    if (key === 'add') {
      nodeKey.value = '';
      nodeValue.value = '';
    }

    if (stateValue[key] !== undefined && key != newKey) {
      delete stateValue[key];
    }

    stateValue[newKey] = newValue;
    this.setValue(stateValue);
  },

  onDelete: function (key) {
    let value = Object.assign({}, this.state.value);

    delete value[key];

    this.setValue(value);
  },

  setValue: function (value) {
    this.setState({
      value: value
    });

    if (this.state.typeIsString) {
      let origin = value;
      value = [];
      for (let key in origin) {
        value.push(key);
        value.push(origin[key]);
      }
      value = value.join(this.delimiter);
    }

    this.props.onChange && this.props.onChange(this.props.name, value);
  },

  render: function () {
    let items = [];
    for (let key in this.state.value) {
      items.push(<tr key={key}>
        <td><input defaultValue={key} ref={key + "-key"}/></td>
        <td><input defaultValue={this.state.value[key]} ref={key + "-value"}/></td>
        <td>
          <Button onClick={this.onSave.bind(this, key)}><I18n message="button.save"/></Button>
        </td>
        <td>
          <Button onClick={this.onDelete.bind(this, key)}><I18n message="button.delete"/></Button>
        </td>
      </tr>);
    }
    return (
      <table className="key_value">
        <thead>
        <tr>
          <th><I18n message="form.key_value.key"/></th>
          <th><I18n message="form.key_value.value"/></th>
          <th colSpan="2"></th>
        </tr>
        </thead>
        <tbody>
        {items}
        <tr>
          <td><input defaultValue="" ref="add-key"/></td>
          <td><input defaultValue="" ref="add-value"/></td>
          <td colSpan="2">
            <Button onClick={this.onSave.bind(this, 'add')}><I18n message="button.add"/></Button>
          </td>
        </tr>
        </tbody>
      </table>
    );
  }
});

export default KeyValue;



// WEBPACK FOOTER //
// ./src/js/Component/Form/KeyValue/Main.jsx